import { useEffect } from "react";
// import { Size } from '../type';
// import { isBrowser, off, on } from '../misc/util';
// import useRafState from './useRafState';
import {inBrowser} from "@firefly/fly-defter"
import addEventListener from "./addEventListener";
import useRafState from "../state/useRafState";

export interface WindowSizeType {
  width: number;
  height: number;
}
/**
 * @see https://github.com/streamich/react-use
 * @param initialWidth
 * @param initialHeight
 */
function useWindowSize(initialWidth = Infinity, initialHeight = Infinity) {
  const [size, setSize] = useRafState<WindowSizeType>({
    width: inBrowser ? window.innerWidth : initialWidth,
    height: inBrowser ? window.innerHeight : initialHeight,
  });

  useEffect(() => {
    if (inBrowser) {
      const handler = () => {
        setSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      const dispose = addEventListener(window, 'resize', handler);
      return () => {
        dispose.remove();
      };
    }
    return () => {

    }
  }, []);

  return size;
}

export default useWindowSize;
